import script from "./BlueChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueChoice.vue?vue&type=script&setup=true&lang=js"

import "./BlueChoice.vue?vue&type=style&index=0&id=773e6627&lang=css"

const __exports__ = script;

export default __exports__